import { Input, FormProps } from 'antd';
import { useTranslation } from 'react-i18next';

import Form from './Form';

export interface OAuthClientFormValues {
  clientName: string;
  publicKey: string;
}

const OAuthClientForm = ({ ...props }: FormProps) => {
  const { t } = useTranslation();

  return (
    <Form<OAuthClientFormValues> {...props}>
      <Form.Item label={t('Nome')} name="clientName" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item label={t('Chave pública')} name="publicKey" rules={[{ required: true }]}>
        <Input.TextArea autoSize={{ minRows: 5, maxRows: 12 }} />
      </Form.Item>
    </Form>
  );
};

export default OAuthClientForm;
